import { render, staticRenderFns } from "./TagItem.vue?vue&type=template&id=49bc9400"
import script from "./TagItem.vue?vue&type=script&lang=js"
export * from "./TagItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports